// Switch — labeled toggle over MUI Switch + FormControlLabel. Good candidate
// for optimistic UI (toggles), per Frontend Rules §11. Controlled.
import PropTypes from 'prop-types';
import MuiSwitch from '@mui/material/Switch';
import FormControlLabel from '@mui/material/FormControlLabel';

export function Switch({ label, checked, onChange, disabled = false, ...rest }) {
  const control = <MuiSwitch checked={!!checked} onChange={onChange} disabled={disabled} {...rest} />;
  if (!label) return control;
  return <FormControlLabel control={control} label={label} />;
}

Switch.propTypes = {
  label: PropTypes.node,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
};

export default Switch;
